import Input from './Input'
import USStatesSelect from '@/components/USStatesSelect'
import CountriesSelect from '@/components/CountriesSelect'

const Select = {
	functional: true,
	props: {
		options: {
			type: Array,
			required: true
		}
	},
	render (h, ctx) {
		const { options } = ctx.props
		return (
			<Input
				input={(input) => {
					return (
						<select value={input.v.$model} onInput={input.onInputHandler} attrs={input.$attrs}>
							{options.map((option) => (
								<option value={option.value} key={option.value}>{option.label}</option>
							))}
						</select>
					)
				}}
				{...ctx.data}
			/>
		)
	}
}

Select.USStates = {
	functional: true,
	render (h, ctx) {
		return (
			<Input
				input={(input) => (
					<USStatesSelect
						onInput={(value) => {
							input.onInputHandler({ target: { value } })
						}}
						value={input.v.$model}
						attrs={input.$attrs}
					/>
				)}
				{...ctx.data}
			/>
		)
	}
}

Select.Countries = {
	functional: true,
	render (h, ctx) {
		return (
			<Input
				input={(input) => (
					<CountriesSelect
						onInput={(value) => {
							input.onInputHandler({ target: { value } })
						}}
						value={input.v.$model}
						attrs={input.$attrs}
					/>
				)}
				{...ctx.data}
			/>
		)
	}
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Form/Select.js